import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '../../_services/authentication.service';
import { LocalService } from '../../_services/local.service';
import { Config } from '../../_helpers/config.class';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {

  headers: HttpHeaders = new HttpHeaders();

  constructor(private http: HttpClient, _authenticationService: AuthenticationService,
    private _localService: LocalService) {
    this.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    this.headers.set('Authorization', 'Bearer ' + _authenticationService.getToken())
  }

  public getDuePayments(skip: number, pageSize: number, query: string, hfId: string, geoLvlCode: string, hfType: string, stockId: number, searchTerm: string) {
    return this.http.post(`${Config.getControllerUrl('Payments', 'GetDuePayments')}`, { Skip: skip, PageSize: pageSize, Query: query, HfId: hfId, GeoLvlCode: geoLvlCode, HfType: hfType, StockId: stockId , Search: searchTerm});
  }

  public getDuePaymentsForInstallments(id: number, fd: Date, td: Date, type: string, bit:boolean, categoryId: number) {
    debugger
    return this.http.post(`${Config.getControllerUrl('Payments', 'GetDuePaymentsForInstallments')}`, { Id: id, FromDate: fd, ToDate: td, Type: type, Bit:bit, categoryId:categoryId });
  }
  public addPaymentForInstallments(obj: any) {
    return this.http.post(
      `${Config.getControllerUrl("Payments", "AddPaymentForInstallments")}`,
      obj
    );
  }

  public getPaymentInstallment(skip: number, pageSize: number, query: string, hfId: string, geoLvlCode: string, hfType: string, stockId: number, searchTerm: string) {
    return this.http.post(`${Config.getControllerUrl('Payments', 'GetPaymentInstallments')}`, { Skip: skip, PageSize: pageSize, Query: query, HfId: hfId, GeoLvlCode: geoLvlCode, HfType: hfType, StockId: stockId , Search: searchTerm});
  }

  public getPaymentMasterRecord(skip: number, pageSize: number, query: string, hfId: string, geoLvlCode: string, hfType: string, stockId: number, searchTerm: string, recordId: number) {
    return this.http.post(`${Config.getControllerUrl('Payments', 'GetPaymentMasterRecord')}`, { Skip: skip, PageSize: pageSize, Query: query, HfId: hfId, GeoLvlCode: geoLvlCode, HfType: hfType, StockId: stockId , Search: searchTerm, RecordId: recordId});
  }
  public getOffsetMasterRecord(skip: number, pageSize: number, query: string, hfId: string, geoLvlCode: string, hfType: string, stockId: number, searchTerm: string, recordId: number, flag: string) {
    return this.http.post(`${Config.getControllerUrl('Payments', 'GetOffsetMasterRecord')}`, { Skip: skip, PageSize: pageSize, Query: query, HfId: hfId, GeoLvlCode: geoLvlCode, HfType: hfType, StockId: stockId , Search: searchTerm, RecordId: recordId, Flag:flag});
  }
  public getOffsetDetailRecord(skip: number, pageSize: number, query: string, hfId: string, geoLvlCode: string, hfType: string, stockId: number, searchTerm: string, recordId: number) {
    return this.http.post(`${Config.getControllerUrl('Payments', 'GetOffsetDetailRecord')}`, { Skip: skip, PageSize: pageSize, Query: query, HfId: hfId, GeoLvlCode: geoLvlCode, HfType: hfType, StockId: stockId , Search: searchTerm, RecordId: recordId});
  }

  public getOffsetDetailRecordByDuePayment(skip: number, pageSize: number, query: string, hfId: string, geoLvlCode: string, hfType: string, stockId: number, searchTerm: string, recordId: number) {
    return this.http.post(`${Config.getControllerUrl('Payments', 'GetOffsetDetailRecordByDuePayment')}`, { Skip: skip, PageSize: pageSize, Query: query, HfId: hfId, GeoLvlCode: geoLvlCode, HfType: hfType, StockId: stockId , Search: searchTerm, RecordId: recordId});
  }

  
  public removeDuePayment(id: number) {
    debugger
    return this.http.post(`${Config.getControllerUrl('Payments', 'RemoveDuePayment')}`, { Id: id });
  }

  public removePaymentInstallment(id: number) {
    debugger
    return this.http.post(`${Config.getControllerUrl('Payments', 'RemovePaymentInstallment')}`, { Id: id });
  }
  public removePaymentMaster(id: number) {
    debugger
    return this.http.post(`${Config.getControllerUrl('Payments', 'RemovePaymentMaster')}`, { Id: id });
  }
  public removeOffsetPaymentMaster(id: number) {
    debugger
    return this.http.post(`${Config.getControllerUrl('Payments', 'RemoveOffsetPaymentMaster')}`, { Id: id });
  }
  public getPaymentMasterById(id: number) {
    debugger
    return this.http.post(`${Config.getControllerUrl('Payments', 'GetPaymentMasterById')}`, { Id: id });
  }

  public getBillingDetail() {
    return this.http.get(`${Config.getControllerUrl('Payment', 'GetFleetClientBillingDetails')}`);
  }

}
